var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.228,
    height: 20.334,
    viewBox: "0 0 21.228 20.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-260.887 -461.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3867",
    transform: "translate(260.887 461.167)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2985",
    d: "M17.106,19.746l-6.511-3.28L4.2,19.97l1.107-7.206L0,7.766,7.2,6.593,10.308,0l3.34,6.481L20.88,7.4l-5.132,5.179Z",
    transform: "translate(0.351 0) rotate(1.007)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3836",
    d: "M352.613,451.38l-3.3,4.5,10.474-3.43Z",
    transform: "translate(-338.708 -444.702)",
    fill: "#ffe680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3838",
    d: "M295.7,492.31v5.585l-6.519,3.346Z",
    transform: "translate(-285.044 -481.231)",
    fill: "#fd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3840",
    d: "M349.81,492.31l6.41,8.761-1.2-7.095Z",
    transform: "translate(-339.155 -481.231)",
    fill: "#fd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3842",
    d: "M253.1,452.534l10.4,3.327-3.213-4.391Z",
    transform: "translate(-252.843 -444.782)",
    fill: "#ffe680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3844",
    d: "M349.81,401.973V391.09l3.207,6.49Z",
    transform: "translate(-339.155 -390.894)",
    fill: "#fd5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3846",
    d: "M289.8,501.15,291.011,494l5.242-1.686Z",
    transform: "translate(-285.597 -481.231)",
    fill: "#ffd42a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOn);
export default __webpack_public_path__ + "static/media/star-on.58c401256e1e46257d5272887b6d3077.svg";
export { ForwardRef as ReactComponent };